import React from "react";
import { useNavigate } from "react-router-dom";
import Shell from "@/components/Shell";
import { Card } from "@/components/ui/card";
import { ShoppingBag, FileText, CaretRight } from "@phosphor-icons/react";

const ReportCard = ({ icon: Icon, tone, title, description, testid, onClick }) => (
  <Card
    onClick={onClick}
    data-testid={testid}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => (e.key === "Enter" ? onClick() : null)}
    className="group cursor-pointer p-6 rounded-none sm:rounded-sm border-slate-200 hover:border-[#1B4776] hover:shadow-md transition-all bg-white flex items-start gap-5"
  >
    <div className={`w-14 h-14 flex items-center justify-center ${tone}`}>
      <Icon size={26} weight="duotone" className="text-white" />
    </div>
    <div className="flex-1">
      <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-500 mb-1">
        Rapor
      </div>
      <div className="text-lg font-bold text-slate-900 font-heading">{title}</div>
      <div className="text-xs text-slate-500 mt-1 leading-relaxed">{description}</div>
    </div>
    <CaretRight
      size={22}
      weight="bold"
      className="text-slate-400 group-hover:text-[#1B4776] group-hover:translate-x-1 transition-all mt-2"
    />
  </Card>
);

export default function PurchaseReportsIndex() {
  const navigate = useNavigate();
  return (
    <Shell
      title="Raporlar"
      subtitle="Satın Alma Yönetimi — İncelemek istediğiniz raporu seçin"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl">
        <ReportCard
          icon={ShoppingBag}
          tone="bg-[#1B4776]"
          title="Satın Alma Raporu"
          description="Talep formu bazlı özet: durum dağılımı, öncelikler, aylık trend, toplam değer ve onay süreleri."
          testid="report-card-purchase"
          onClick={() => navigate("/satin-alma/rapor/satin-alma")}
        />
        <ReportCard
          icon={FileText}
          tone="bg-emerald-600"
          title="Teklif Raporu"
          description="Talep firmalarına gönderim/yanıt bazlı: hangi firma teklif verdi/vermedi, yanıt oranı, ortalama yanıt süresi."
          testid="report-card-rfq"
          onClick={() => navigate("/satin-alma/rapor/teklif")}
        />
      </div>
    </Shell>
  );
}
